import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FIELD_H = 40; // keep in sync with FIELD_H in the booking form

export default function MyDatePicker({
  label,
  value,
  onChange,
  placeholder = "DD/MM/YYYY",
  containerStyle,
  inputStyle,
  labelStyle,
}) {
  const [open, setOpen] = React.useState(false);

  const safeDate = React.useMemo(() => {
    if (!value) return null;

    if (value instanceof Date) return value;

    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split("-").map(Number);
      return new Date(y, m - 1, d);
    }

    if (typeof value === "string" && value.includes("T")) {
      const [y, m, d] = value.substring(0, 10).split("-").map(Number);
      return new Date(y, m - 1, d);
    }

    return null;
  }, [value]);

  const handleChange = (date) => {
    if (!date) {
      onChange(null);
      return;
    }
    onChange(date);
  };

  return (
    <div
      style={{
        position: "relative",
        marginBottom: 0,
        width: 180,
        ...containerStyle,
      }}
    >
      {/* Floating label sitting on the border, same as the MUI text fields */}
      <label
        style={{
          position: "absolute",
          top: -8,
          left: 10,
          padding: "0 4px",
          fontSize: 13,
          fontWeight: 400,
          lineHeight: "16px",
          color: open ? "#1d4ed8" : "#0f172a",  // was #64748b
          background: "#fff",
          zIndex: 2,
          pointerEvents: "none",
          ...labelStyle,
        }}
      >
        {label}
      </label>

      <DatePicker
        selected={safeDate}
        onChange={handleChange}
        onCalendarOpen={() => setOpen(true)}
        onCalendarClose={() => setOpen(false)}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        /* fixes clipping everywhere */
        portalId="root"
        popperPlacement="bottom-start"
        popperProps={{ strategy: "fixed" }}
        wrapperClassName="mydp-wrapper"
        customInput={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              boxSizing: "border-box",
              width: "100%",
              height: FIELD_H,
              border: `1px solid ${open ? "#1d4ed8" : "#e2e8f0"}`,
              boxShadow: open ? "0 0 0 3px rgba(29,78,216,0.12)" : "none",
              borderRadius: 8,
              padding: "0 12px",
              background: "#fff",
              cursor: "pointer",
              transition: "border-color .15s, box-shadow .15s",
              ...inputStyle,
            }}
          >
            <input
              type="text"
              value={safeDate ? safeDate.toLocaleDateString("en-GB") : ""}
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                height: "100%",
                padding: 0,
                fontSize: 13,
                fontFamily: "inherit",
                color: "#0f172a",
                background: "transparent",
                cursor: "pointer",
              }}
              placeholder={placeholder}
              readOnly
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="#64748b"
              viewBox="0 0 24 24"
              style={{ marginLeft: 4, flexShrink: 0 }}
            >
              <path d="M7 10h5v5H7z"></path>
              <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"></path>
            </svg>
          </div>
        }
      />

      {/* make react-datepicker's own wrapper fill the container */}
      <style>{`
        .mydp-wrapper { display: block !important; width: 100%; }
        .mydp-wrapper .react-datepicker__input-container { display: block; width: 100%; }
      `}</style>
    </div>
  );
}
